import React from 'react';

function Terms() {

  return (
    <div style={{
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
      padding: '40px 0'
    }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="text-center mb-5">
              <h1 className="display-4 fw-bold text-primary mb-3">
                <i className="fas fa-file-contract text-warning me-3"></i>
                Términos de Servicio
              </h1>
              <p className="lead text-muted">
                Lee atentamente nuestros términos de servicio antes de usar nuestro sitio.
              </p>
              <p className="text-muted small">
                Última actualización: {new Date().toLocaleDateString('es-ES')}
              </p>
            </div>

            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row">
                  <div className="col-lg-3">
                    <nav className="nav flex-column nav-pills">
                      <a className="nav-link active" href="#aceitacao">Aceptación</a>
                      <a className="nav-link" href="#servicos">Servicios</a>
                      <a className="nav-link" href="#pedidos">Pedidos y Pagos</a>
                      <a className="nav-link" href="#entregas">Entregas</a>
                      <a className="nav-link" href="#devolucoes">Devoluciones</a>
                      <a className="nav-link" href="#responsabilidades">Responsabilidades</a>
                      <a className="nav-link" href="#propriedade">Propiedad Intelectual</a>
                      <a className="nav-link" href="#privacidade">Privacidad</a>
                      <a className="nav-link" href="#modificacoes">Modificaciones</a>
                      <a className="nav-link" href="#contato">Contacto</a>
                    </nav>
                  </div>
                  
                  <div className="col-lg-9">
                    <div id="aceitacao" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-check-circle me-2"></i>
                        Aceptación de los Términos
                      </h3>
                      <p>
                        Al acceder y usar este sitio, aceptas cumplir y estar vinculado a estos Términos de Servicio. Si no aceptas cualquier parte de estos términos, no debes usar nuestro sitio.
                      </p>
                      <p>
                        Estos términos se aplican a todos los usuarios del sitio, incluyendo sin limitación usuarios que son navegadores, proveedores, clientes, comerciantes y/o contribuidores de contenido.
                      </p>
                    </div>

                    <div id="servicos" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-shopping-cart me-2"></i>
                        Descripción de los Servicios
                      </h3>
                      <p>Nuestro sitio ofrece los siguientes servicios:</p>
                      <ul>
                        <li>Venta de productos de moda y accesorios</li>
                        <li>Procesamiento de pedidos online</li>
                        <li>Entrega de productos</li>
                        <li>Atención al cliente</li>
                        <li>Programa de fidelidad</li>
                      </ul>
                      <p>
                        Nos reservamos el derecho de modificar, suspender o discontinuar cualquier aspecto de nuestros servicios en cualquier momento, con o sin aviso previo.
                      </p>
                    </div>

                    <div id="pedidos" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-credit-card me-2"></i>
                        Pedidos y Pagos
                      </h3>
                      <p><strong>Procesamiento de Pedidos:</strong></p>
                      <ul>
                        <li>Todos los pedidos están sujetos a disponibilidad de stock</li>
                        <li>Nos reservamos el derecho de rechazar cualquier pedido</li>
                        <li>Los precios pueden ser cambiados sin aviso previo</li>
                        <li>Tasas de envío serán agregadas según aplicable</li>
                      </ul>
                      
                      <p><strong>Formas de Pago:</strong></p>
                      <ul>
                        <li>Tarjetas de crédito y débito</li>
                        <li>Transferencias bancarias</li>
                        <li>Pago contra entrega</li>
                        <li>Pago via WhatsApp (para pedidos específicos)</li>
                      </ul>
                      
                      <p>
                        <strong>Confirmación:</strong> Recibirás una confirmación por email después del procesamiento exitoso de tu pedido.
                      </p>
                    </div>

                    <div id="entregas" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-truck me-2"></i>
                        Política de Entregas
                      </h3>
                      <p><strong>Plazos de Entrega:</strong></p>
                      <ul>
                        <li>Región Metropolitana: 1-2 días hábiles</li>
                        <li>Demas regiones: 3-7 días hábiles</li>
                        <li>Pedidos hechos después de 14h serán procesados al próximo día hábil</li>
                      </ul>
                      
                      <p><strong>Rastreo:</strong></p>
                      <ul>
                        <li>Recibirás un código de rastreo por email</li>
                        <li>El rastreo estará disponible en nuestro sitio</li>
                        <li>Notificaciones de status serán enviadas por email</li>
                      </ul>
                      
                      <p>
                        <strong>Responsabilidad:</strong> No nos responsabilizamos por atrasos causados por factores fuera de nuestro control, como condiciones climáticas o problemas de transporte.
                      </p>
                    </div>

                    <div id="devolucoes" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-undo me-2"></i>
                        Política de Devoluciones y Cambios
                      </h3>
                      <p><strong>Plazo para Devoluciones:</strong></p>
                      <ul>
                        <li>30 días a partir de la fecha de recepción</li>
                        <li>Productos deben estar en estado original</li>
                        <li>Etiquetas y embalajes deben estar intactas</li>
                      </ul>
                      
                      <p><strong>Productos No Aceptados para Devolución:</strong></p>
                      <ul>
                        <li>Productos personalizados o a medida</li>
                        <li>Productos de higiene personal</li>
                        <li>Productos en promoción o liquidación</li>
                        <li>Productos dañados por uso inadecuado</li>
                      </ul>
                      
                      <p><strong>Proceso de Devolución:</strong></p>
                      <ul>
                        <li>Contactanos para solicitar la devolución</li>
                        <li>Envía el producto de vuelta en hasta 7 días</li>
                        <li>Reembolso será procesado en hasta 14 días hábiles</li>
                      </ul>
                    </div>

                    <div id="responsabilidades" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-balance-scale me-2"></i>
                        Limitaciones de Responsabilidad
                      </h3>
                      <p>
                        En ninguna circunstancia seremos responsables por daños indirectos, incidentales, especiales, punitivos o consecuentes, incluyendo pérdida de ganancias, datos o uso.
                      </p>
                      <p>
                        Nuestra responsabilidad total en cualquier caso no excederá el valor pagado por el producto o servicio en cuestión.
                      </p>
                      <p>
                        No garantizamos que el sitio estará siempre disponible o libre de errores, virus u otros componentes perjudiciales.
                      </p>
                    </div>

                    <div id="propriedade" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-copyright me-2"></i>
                        Propiedad Intelectual
                      </h3>
                      <p>
                        Todo el contenido de este sitio, incluyendo textos, gráficos, logotipos, íconos, imágenes y software, es propiedad nuestra o de nuestros licenciadores y está protegido por leyes de derechos de autor.
                      </p>
                      <p>
                        Está prohibida la reproducción, distribución, modificación o uso comercial de cualquier contenido sin nuestra autorización expresa por escrito.
                      </p>
                    </div>

                    <div id="privacidade" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-user-shield me-2"></i>
                        Privacidad y Protección de Datos
                      </h3>
                      <p>
                        Tu privacidad es importante para nosotros. La recopilación, uso y protección de tu información personal están regidos por nuestra Política de Privacidad.
                      </p>
                      <p>
                        Al usar nuestro sitio, aceptas la recopilación y uso de información conforme a lo descrito en nuestra Política de Privacidad.
                      </p>
                    </div>

                    <div id="modificacoes" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-edit me-2"></i>
                        Modificaciones de los Términos
                      </h3>
                      <p>
                        Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación en el sitio.
                      </p>
                      <p>
                        Es tu responsabilidad revisar periódicamente estos términos. El uso continuo del sitio después de las modificaciones constituye aceptación de los nuevos términos.
                      </p>
                    </div>

                    <div id="contato" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-envelope me-2"></i>
                        Contáctanos
                      </h3>
                      <p>Para dudas sobre estos términos:</p>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="card bg-light">
                            <div className="card-body">
                              <h6 className="fw-bold">Email</h6>
                              <p className="mb-0">contacto@asmarshop.com</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="card bg-light">
                            <div className="card-body">
                                                         <h6 className="fw-bold">Teléfono</h6>
                           <p className="mb-0">+595 21 123-4567</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="alert alert-warning">
                      <h6 className="fw-bold">
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        Aviso Legal
                      </h6>
                      <p className="mb-0">
                        Estos términos constituyen un acuerdo legal entre tú y nuestra empresa. Recomendamos que los leas cuidadosamente y consultes a un abogado si tienes dudas sobre tus obligaciones legales.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
